var map = {
	"./boots/overall/yellow.jpg": "1992",
	"./gloves/overall/yellow.jpg": "57ae",
	"./jackets/back/yellow.jpg": "67db",
	"./jackets/chest/yellow.jpg": "1a3c",
	"./jackets/elbow/yellow.jpg": "41d5",
	"./jackets/shoulder/yellow.jpg": "39a8",
	"./pants/hip/yellow.jpg": "53af",
	"./pants/knee/yellow.jpg": "2b97",
	"./pants/tailbone/yellow.jpg": "d279"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c0b9";